import { WrapRootElementBrowserArgs } from 'gatsby';
import React, { ReactNode } from 'react';
import MuiThemeProvider from './src/components/MuiThemeProvider';

export const wrapRootElement = ({
  element,
}: WrapRootElementBrowserArgs): ReactNode => {
  return <MuiThemeProvider>{element as ReactNode}</MuiThemeProvider>;
};
